import React from 'react';
import ScrollToBottom from 'react-scroll-to-bottom';

import { Container } from './style';

interface IConditionalScrollToBottomProps {
  disabled: boolean;
  children: React.ReactNode;
  className?: string;
}

const ConditionalScrollToBottom = ({
  disabled,
  children,
  className = 'scroll-style',
}: IConditionalScrollToBottomProps) => {
  if (disabled) {
    return <Container className={className}>{children}</Container>;
  }
  return <ScrollToBottom className={className}>{children}</ScrollToBottom>;
};

export default ConditionalScrollToBottom;
